import { AxiosInstance } from "axios"
import { AccountingCustomer } from "../../../../modules/merchant/accounting/accounting/accountingApi"

export enum CreateOrderOnBehalfOfQuery {
    COMPANIES_MERCHANT = "on-behalf-of-companies-for-merchant",
    USERS_MERCHANT = "on-behalf-of-users-for-merchant",
    COMPANIES_SERVICE_CENTER = "on-behalf-of-companies-for-service-center",
    COMPANIES_USERS_SERVICE_CENTER = "on-behalf-of-users-for-service-center",
}

export type OrderOnBehalfOfCompaniesResponse = Readonly<{
    customers: AccountingCustomer[]
}>

type OrderOnBehalfOfCompaniesForMerchantParam = Readonly<{
    merchantId: number
}>

export async function fetchOrderOnBehalfOfCompaniesForMerchant(
    { merchantId }: OrderOnBehalfOfCompaniesForMerchantParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<OrderOnBehalfOfCompaniesResponse> {
    const url = `/merchants/${merchantId}/accounting/customers`
    const { data } = await axios.get(url, {
        signal,
        params: {},
    })

    return data
}

type OrderOnBehalfOfUsersForMerchantParam = Readonly<{
    merchantId: number
    companyId?: string
    userGroupId?: string
    searchText?: string
}>

export type OrderOnBehalfOfUser = Readonly<{
    id: number
    displayName: string
}>

export type OrderOnBehalfOfUsersForMerchantResponse = Readonly<{
    users: OrderOnBehalfOfUser[]
}>

export async function fetchOrderOnBehalfOfUsersForMerchant(
    { merchantId, ...rest }: OrderOnBehalfOfUsersForMerchantParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<OrderOnBehalfOfUsersForMerchantResponse> {
    const url = `/merchants/${merchantId}/orders/users`
    const { data } = await axios.get(url, {
        signal,
        params: rest,
    })

    return data
}

type OrderOnBehalfOfCompaniesForServiceCenterParam = Readonly<{
    serviceCenterId: number
}>

export async function fetchOrderOnBehalfOfCompaniesForServiceCenter(
    { serviceCenterId }: OrderOnBehalfOfCompaniesForServiceCenterParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<OrderOnBehalfOfCompaniesResponse> {
    const url = `/serviceCenters/${serviceCenterId}/companies`
    const { data } = await axios.get(url, {
        signal,
        params: {},
    })

    return data
}

type OrderOnBehalfOfUsersForServiceCenterParam = Readonly<{
    serviceCenterId: number
    companyId: string
    userGroupId?: string
    searchText?: string
}>

export async function fetchOrderOnBehalfOfUsersForServiceCenter(
    { serviceCenterId, companyId, ...rest }: OrderOnBehalfOfUsersForServiceCenterParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<OrderOnBehalfOfUsersForMerchantResponse> {
    const url = `/serviceCenters/${serviceCenterId}/companies/${companyId}/users`
    const { data } = await axios.get(url, {
        signal,
        params: rest,
    })

    return data
}
